import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ConversationHeader = ({ 
  conversation, 
  onBack, 
  onSearch, 
  onBlock, 
  onReport,
  onDelete 
}) => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <div className="flex items-center justify-between px-6 py-4 bg-white border-b border-gray-100">
      {/* Left Side - Back Button + User Info */}
      <div className="flex items-center gap-4">
        {/* Back Button (Mobile) */}
        <button
          onClick={onBack}
          className="lg:hidden p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <Icon name="ArrowLeft" size={20} color="#54656f" />
        </button>

        {/* User Avatar */}
        <div className="w-10 h-10 rounded-full overflow-hidden">
          {conversation?.avatar ? (
            <img
              src={conversation?.avatar}
              alt={conversation?.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full bg-blue-600 flex items-center justify-center text-white font-medium">
              {conversation?.name?.charAt(0)?.toUpperCase()}
            </div>
          )}
        </div>

        {/* User Info */}
        <div>
          <h2 className="font-semibold" style={{ color: '#111b21' }}>
            {conversation?.name}
          </h2>
          <p className="text-xs" style={{ color: '#667781' }}>
            {conversation?.type === 'group' ? `${conversation?.memberCount || 0} üye` : 'Çevrimiçi'}
          </p>
        </div>
      </div>

      {/* Right Side - Actions */}
      <div className="flex items-center gap-2">
        <button
          onClick={onSearch}
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          title="Ara"
        >
          <Icon name="Search" size={20} color="#54656f" />
        </button>

        {/* More Menu */}
        <div className="relative">
          <button
            onClick={() => setShowMenu(!showMenu)}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            title="Daha fazla"
          >
            <Icon name="MoreVertical" size={20} color="#54656f" />
          </button>

          {/* Dropdown Menu */}
          {showMenu && (
            <div className="absolute right-0 mt-2 py-2 rounded-lg shadow-lg z-10 min-w-[180px] bg-white border border-gray-100">
              <button
                onClick={() => {
                  onBlock?.();
                  setShowMenu(false);
                }}
                className="w-full px-4 py-2 text-sm text-left hover:bg-gray-50 flex items-center gap-3"
                style={{ color: '#111b21' }}
              >
                <Icon name="UserX" size={16} color="#54656f" />
                Engelle
              </button>
              <button
                onClick={() => {
                  onReport?.();
                  setShowMenu(false);
                }}
                className="w-full px-4 py-2 text-sm text-left hover:bg-gray-50 flex items-center gap-3"
                style={{ color: '#111b21' }}
              >
                <Icon name="Flag" size={16} color="#54656f" />
                Şikayet Et
              </button>
              <div className="h-px my-1 bg-gray-100"></div>
              <button
                onClick={() => {
                  onDelete?.();
                  setShowMenu(false);
                }}
                className="w-full px-4 py-2 text-sm text-left hover:bg-red-50 flex items-center gap-3"
                style={{ color: '#d32f2f' }}
              >
                <Icon name="Trash2" size={16} color="#d32f2f" />
                Sohbeti Sil
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Click outside to close menu */}
      {showMenu && (
        <div
          className="fixed inset-0 z-0"
          onClick={() => setShowMenu(false)}
        ></div>
      )}
    </div>
  );
};

export default ConversationHeader;